import { render, staticRenderFns } from "./recycleFont.vue?vue&type=template&id=0e5180ce&scoped=true&"
import script from "./recycleFont.vue?vue&type=script&lang=js&"
export * from "./recycleFont.vue?vue&type=script&lang=js&"
import style0 from "./recycleFont.vue?vue&type=style&index=0&id=0e5180ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5180ce",
  null
  
)

export default component.exports